import React, { useState, useEffect, Component } from 'react';
import { TweenMax } from 'gsap';
import { Link } from 'gatsby';
import style from './style.module.scss'
import { Zoom, Fade } from 'react-reveal';
import { ItemTypes } from '../../Constants';
import { createItemUrl } from '../../Utils';
import LottieLoading from 'react-lottie';
import animationData from '../../LottieAnimations/bouncing_circles.json';
import NoImage from '../NoImage';
import instagram from '../../images/instagram.png';
import facebook from '../../images/facebook.png';
import twitter from '../../images/twitter.png';

const SocialIcon = (props) => {
    let self = null;


    const onMouseEnter = () => {
        TweenMax.to(self, 0.2, {
            scale: 1.1
        })
    }

    const onMouseLeave = () => {
        TweenMax.to(self, 0.2, {
            scale: 1.0
        })
    }

    const { imgSrc, link, alt } = props
    return (
        <a ref={ref => self = ref} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} href={link} target="_blank">
            <span>
                <img className={style.socialMediaIcon} src={imgSrc} alt={alt} />
            </span>
        </a>
    )
}

class RecipeCell extends Component {


    state = {
        hasImageLoaded: false
    }

    componentDidMount() {
        let { photos = [] } = this.props.data
        let { location = '' } = photos[0] || {}
        if (location) {
            var recipeImage = new Image;
            recipeImage.onload = () => this.setState({ hasImageLoaded: true })
            recipeImage.src = location
        } else { this.setState({ hasImageLoaded: true }) }
    }

    onMouseEnter = () => {
        TweenMax.to(this.cell, 0.2, {
            scale: 1.1
        })
    }

    onMouseLeave = () => {
        TweenMax.to(this.cell, 0.2, {
            scale: 1.0
        })
    }

    toggleLoadingImage = () => {
        const defaultOptions = {
            loop: true,
            autoplay: true,
            animationData: animationData,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
            }
        };
        return <LottieLoading
            options={defaultOptions}
            height={400}
            width={400} />
    }


    render() {
        let { name = 'N/A', id = null, photos = [] } = this.props.data
        let { location = '' } = photos[0] || {}
        const recipeUrl = createItemUrl(id, ItemTypes.recipe);
        return (
            <Zoom>
                <div
                    state={{ index: this.props.index }}
                    className={`${style.recipeWrapper} ${this.themeClass}`}>
                    <div ref={e => this.cell = e} className={`${style.card} ${this.props.cardClass}`}>
                        {location ?
                            <Link ref={e => this.link = e} to={recipeUrl}
                                state={{ index: this.props.index }}>
                                <span className={style.recipeImage}>
                                    {this.state.hasImageLoaded ?
                                        <img src={location} /> : this.toggleLoadingImage()

                                    }
                                </span>
                            </Link>
                            :
                            <Link ref={e => this.link = e} to={recipeUrl}
                                state={{ index: this.props.index }}>
                                <NoImage />
                            </Link>}
                        <div className={style.descriptionSection}>
                            <Link ref={e => this.link = e} to={recipeUrl}
                                state={{ index: this.props.index }}>
                                <Fade top><h1 className={style.recipeName}>{name}</h1></Fade>
                            </Link>
                            <Fade bottom>
                                <div className={style.socialMediaSection}>
                                    <SocialIcon imgSrc={facebook} link="https://www.facebook.com/Holsumpr/" alt="FACEBOOK" />
                                    <SocialIcon imgSrc={instagram} link="https://www.instagram.com/holsumpuertorico/" alt="INSTAGRAM" />
                                    <SocialIcon imgSrc={twitter} link="https://twitter.com/hashtag/holsumpr" alt="TWITTER" />
                                </div>
                            </Fade>
                        </div>
                    </div>
                </div>
            </Zoom>
        )
    }
}


export default RecipeCell